import { ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { DxTextAreaComponent } from "devextreme-angular";
import { DemoInstance } from "src/app/core";
import { DemoInstancesService } from "src/app/services/demo-instances.service";
import { getIntendedUseDescription, IntendedUseEnum } from "src/app/core/model/IntendedUses";
import { DatePipe } from "@angular/common";

@Component({
  selector: "brd-instance-tile-info",
  templateUrl: "./instance-tile-info.component.html",
  styleUrl: "./instance-tile-info.component.less",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  providers: [DatePipe]
})
export class InstanceTileInfoComponent implements OnInit {
  @ViewChild("textArea") textArea!: DxTextAreaComponent;
  @ViewChild("demoComposition", { read: TemplateRef, static: true }) demoCompositionTemplate!: TemplateRef<unknown>;
  @Input() instance!: DemoInstance;

  isEditing: boolean = false;
  popupInfo: { id: string; label: string; value: string; template?: TemplateRef<unknown> }[] = [];

  constructor(
    private instanceService: DemoInstancesService,
    private destroyRef: DestroyRef,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.popupInfo = [
      {
        id: "creationDate",
        label: "creation date",
        value: this.instance.creationDate ? this.datePipe.transform(this.instance.creationDate, "MM/dd/yyyy") : "-"
      },
      {
        id: "expDate",
        label: "expiration date",
        value: this.instance.expirationDate ? this.datePipe.transform(this.instance.expirationDate, "MM/dd/yyyy") : "-"
      },
      { id: "region", label: "region", value: this.instance.regionName },
      {
        id: "type",
        label: "type & demos included",
        value: this.instance.templateSuggested ? `Suggested - ${this.instance.template}` : "Custom",
        template: this.demoCompositionTemplate
      },
      {
        id: "use",
        label: "intended use",
        value: this.instance.intendedUse !== undefined ? getIntendedUseDescription(this.instance.intendedUse) : "-"
      },
      {
        id: "comment",
        label: this.instance.intendedUse === IntendedUseEnum.opportunity ? "opportunity name" : "comment",
        value: this.instance.prospect ?? "-"
      }
    ];
  }

  undoNoteEdit(): void {
    this.isEditing = false;
    this.textArea.value = this.instance.comment;
  }

  saveNoteEdit(): void {
    this.isEditing = false;
    this.instanceService.updateNote(this.instance.id, this.textArea.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }
}
